// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/pen-tool.js';

import { paths } from '../generated/pen-tool';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('pen-tool', Original, paths);
